import BaseEntity from "../domain/BaseEntity";
import StringUtil from "./StringUtil";

export default class ObjectUtil {
    private static _undefined;

    public static get undefined() {
        return this._undefined;
    }

    public static defaultIfNull(object: any, defaultValue: any): any {
        return object === undefined || object === null ? defaultValue : object;
    }

    public static equalsAny(object: any, ...searches: any[]): boolean {
        return searches.findIndex((search) => search === object) !== -1;
    }

    public static isEmpty(object: any): boolean {
        for (const key in object) {
            return false;
        }

        return true;
    }

    public static joinKeyValues(array: any[], key: string, separator?: string) {
        return array
            .filter((rowData) => rowData[key] != null)
            .map((rowData) => rowData[key])
            .join(separator || ",");
    }

    public static extendBaseEntity(obj: any) {
        const extenedEntity = Object.assign(new BaseEntity(), obj);
        return Object.assign(obj, extenedEntity);
    }

    public static convertKeysToCamelCase<T>(input: any) {
        let output:T;

        // If it's an Array, perform the recursive call on each element
        if (Array.isArray(input)) {
            output = input.map(element => this.convertKeysToCamelCase(element)) as T;
        } else if (typeof input === 'object' && input !== null) {
            // If it's an Object, perform the key conversion
            output = {} as T;
            for (let key in input) {
                let newKey = StringUtil.upperSnakeToCamel(key);
                output[newKey] = this.convertKeysToCamelCase(input[key]);
            }
        } else {
            // Not an object or array, just return the value
            output = input;
        }

        return output;


    }
}
